







































import { Component, Vue, Watch } from 'vue-property-decorator'

import { namespace } from 'vuex-class'

const kycFormStore = namespace('KYCFormStore')
const kycSectionStore = namespace('KYCSectionStore')

@Component
export default class TheCompletionCheckModal extends Vue {
  @kycFormStore.State
  private computedValidationResult: {}

  @kycFormStore.State
  private showCompletionModalState

  @kycSectionStore.State
  private sections: { name: string; url: string; completed: boolean; allowed: boolean; subs?: any[] } []

  @kycFormStore.Action
  private updateShowCompletionModalState!: (state) => void

  private isSectionDisplay = true
  private activeName = 'first'
  private currentSection = ''

  // Getters

  get isSectionCompleted () {
    return this.organisedValidation[this.currentSection] === null ||
            typeof this.organisedValidation[this.currentSection] === 'undefined'
  }

  // Methods

  private organisedValidation = {}

  organiseValidationToSection () {
    console.time('organising validation')
    this.organisedValidation = {}
    for (let index = 0; index < this.sections.length; index++) {
      const section = this.sections[index]
      if (section.subs) {
        section.completed = true
        const subsections = section.subs
        for (let subIndex = 0; subIndex < subsections.length; subIndex++) {
          const result = this.computedValidationResult[subsections[subIndex].name]
          if (result) {
            this.organisedValidation[subsections[subIndex].name] = result
          }
        }

        for (let subIndex = 0; subIndex < subsections.length; subIndex++) {
          section.completed =
            section.completed && subsections[subIndex].completed
        }
      } else {
        const result = this.computedValidationResult[section.name]
        if (result) {
          this.organisedValidation[section.name] = result
        }
      }
    }
    console.timeEnd('organising validation')
  }

  // Watchers

  @Watch('showCompletionModalState')
  displaySection () {
    this.organiseValidationToSection()
    this.currentSection = this.$router.currentRoute.name
    this.isSectionDisplay = this.currentSection !== 'KYC Confirmation'
    if (!this.isSectionDisplay) {
      this.activeName = 'second'
    } else {
      this.activeName = 'first'
    }
  }
}
